export default __webpack_public_path__ + "static/media/04AW3JUL66.8540a085.jpg";